const AdidasDATA = [
    {
        id : 0,
        title : "Adidas X Speedflow",
        price : 74.99,
        desc : "Adidas X Speedflow Firm-Ground Football Boot",
        img : "/assets/images/products/Adidas/1.png",
        img2 : "/assets/images/products/Adidas/img2/1.png",
        img3 : "/assets/images/products/Adidas/img3/1.png",
        img4 : "/assets/images/products/Adidas/img4/1.png",
        img5 : "/assets/images/products/Adidas/img5/1.png"
    },
    {
        id : 1,
        title : "adidas Predator Freak",
        price : 94.99,
        desc : "Adidas X Speedflow Firm-Ground Football Boot",
        img : "/assets/images/products/Adidas/2.png",
        img2 : "/assets/images/products/Adidas/img2/2.png",
        img3 : "/assets/images/products/Adidas/img3/2.png",
        img4 : "/assets/images/products/Adidas/img4/2.png",
        img5 : "/assets/images/products/Adidas/img5/2.png"
    },
    {
        id : 2,
        title : "Adidas Edge of Darkness",
        price : 119.99,
        desc : "Adidas X Speedflow Firm-Ground Football Boot",
        img : "/assets/images/products/Adidas/3.png",
        img2 : "/assets/images/products/Adidas/img2/3.png",
        img3 : "/assets/images/products/Adidas/img3/3.png",
        img4 : "/assets/images/products/Adidas/img4/3.png",
        img5 : "/assets/images/products/Adidas/img5/3.png"
    },
    {
        id : 3,
        title : "Adidas Copa Sense",
        price : 174.99,
        desc : "Adidas Copa Sense Firm-Ground Football Boot",
        img : "/assets/images/products/Adidas/4.png",
        img2 : "/assets/images/products/Adidas/img2/4.png",
        img3 : "/assets/images/products/Adidas/img3/4.png",
        img4 : "/assets/images/products/Adidas/img4/4.png",
        img5 : "/assets/images/products/Adidas/img5/4.png"
    }
]
export default AdidasDATA;